import React, { useState } from "react";

import { Editor, ExpandIcon, Label } from "@packages/ds";

import ModalIDE from "./ModalIDE";
import * as S from "./styles";

type IdeFieldProps = {
  id: string;
  label: string;
  value?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  required: boolean;
  expandable: boolean;
  options: Record<string, unknown>;
  width: string | number;
  height: string | number;
};

const IdeField = ({
  id,
  label,
  value,
  onChange,
  required = true,
  width = "100%",
  height = 600,
  options = {},
  expandable = false
}: IdeFieldProps) => {
  const [isModalOpen, toggleModal] = useState(false);

  const handleChange = (newValue: string) => {
    onChange({
      persist: () => {},
      preventDefault: () => {},
      target: {
        type: "text",
        value: newValue,
        name: id
      }
    } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <S.Wrapper className="field ide-field">
      <S.Header>
        {label && (
          <Label htmlFor={id} required={required}>
            {label}
          </Label>
        )}

        <S.Buttons>
          {expandable && (
            <S.Button onClick={() => toggleModal(true)}>
              <ExpandIcon />
            </S.Button>
          )}
        </S.Buttons>
      </S.Header>
      <Editor
        width={width}
        height={height}
        value={value}
        options={options}
        onChange={handleChange}
      />
      {expandable && isModalOpen && (
        <ModalIDE
          title={label}
          value={value}
          onSave={handleChange}
          closeModal={() => toggleModal(false)}
        />
      )}
    </S.Wrapper>
  );
};

export default IdeField;
